import { render, staticRenderFns } from "./age-limit.vue?vue&type=template&id=29478144&scoped=true"
import script from "./age-limit.vue?vue&type=script&lang=js"
export * from "./age-limit.vue?vue&type=script&lang=js"
import style0 from "./age-limit.vue?vue&type=style&index=0&id=29478144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29478144",
  null
  
)

export default component.exports